/* ==========================================================================
   ETIQUETTE CART DRAWER — etq-cart.js  (FULL FILE)
   - Savings bar live update
   - Header item count live update
   - Coupon COPY buttons (clipboard + fallback, does NOT close drawer)
   - Upsell recommendations (fetch + render)
   - Upsell ADD to cart (refreshes drawer, does NOT close it)
   - Permanent upsell guard: auto-refills the section whenever it goes empty
   ========================================================================== */
(function () {
  function formatMoney(cents) {
    // INR money format: "Rs. 1,400.00" with Indian (lakh) grouping
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var lastThree = intPart.slice(-3);
    var rest = intPart.slice(0, -3);
    if (rest !== '') {
      lastThree = ',' + lastThree;
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    }
    return 'Rs. ' + rest + lastThree + '.' + decPart;
  }

  function refreshCartExtras() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // --- Savings bar ---
        var savings = cart.original_total_price - cart.total_price;
        var bar = document.querySelector('.etq-cart__savings');
        var amountEl = document.querySelector('.etq-cart__savings-amount');
        if (bar && amountEl) {
          if (savings > 0) {
            amountEl.textContent = formatMoney(savings);
            bar.style.display = '';
          } else {
            bar.style.display = 'none';
          }
        }

        // --- Header item count ---
        var countEl = document.querySelector('.etq-cart__count');
        if (countEl) {
          var label = cart.item_count === 1 ? 'item' : 'items';
          countEl.textContent = '(' + cart.item_count + ' ' + label + ')';
        }
      })
      .catch(function () { /* silent — keeps last value */ });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', refreshCartExtras);

  // Re-run whenever Dawn's cart-drawer.js replaces the items node
  function observeCart() {
    var target = document.getElementById('CartDrawer-CartItems');
    if (!target) { setTimeout(observeCart, 500); return; }
    var observer = new MutationObserver(function () { refreshCartExtras(); });
    observer.observe(target, { childList: true, subtree: true });
  }
  observeCart();

  // ----- Coupon copy buttons -----
  // (Coupon section may be removed; harmless if no buttons exist.)
  function copyCode(btn) {
    var code = btn.getAttribute('data-code') || '';
    if (!code) return;

    if (!btn.getAttribute('data-label')) {
      btn.setAttribute('data-label', btn.textContent.trim() || 'Copy');
    }

    function showCopied() {
      btn.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-label') || 'Copy';
        btn.classList.remove('is-copied');
      }, 1500);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(showCopied).catch(function () {
        fallbackCopy(code); showCopied();
      });
    } else {
      fallbackCopy(code); showCopied();
    }
  }

  function bindCouponButtons() {
    var buttons = document.querySelectorAll('.etq-cart__coupon-copy');
    buttons.forEach(function (btn) {
      if (btn.dataset.etqBound) return;
      btn.dataset.etqBound = '1';
      ['pointerup', 'touchend', 'click'].forEach(function (evt) {
        btn.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          copyCode(btn);
        }, false);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindCouponButtons);
  bindCouponButtons();
  (function watchForCoupons() {
    var t = document.getElementById('CartDrawer');
    if (!t) { setTimeout(watchForCoupons, 500); return; }
    new MutationObserver(bindCouponButtons).observe(t, { childList: true, subtree: true });
  })();

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    ta.style.pointerEvents = 'none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  // ----- Upsell recommendations (fetch + render, with cache) -----
  var upsellCacheHTML = null;   // cached <ul> of cards
  var upsellCacheSeed = null;   // seed the cache was built from

  function loadUpsell(force) {
    var wrap = document.getElementById('etq-upsell');
    var target = document.getElementById('etq-upsell-scroll');
    if (!wrap || !target) return;

    var hasCards = target.querySelectorAll('.etq-upsell__card').length > 0;
    if (!force && hasCards) return;

    // If we have cached cards, inject them instantly (no network wait).
    if (upsellCacheHTML) {
      target.innerHTML = upsellCacheHTML;
      wrap.style.display = '';
      bindUpsellAdd();
      // Still refresh the cache in the background in case the seed changed.
      refreshUpsellCache(wrap, false);
      return;
    }

    // No cache yet — fetch fresh.
    refreshUpsellCache(wrap, true);
  }

  function refreshUpsellCache(wrap, injectAfter) {
    var base = wrap.getAttribute('data-url') || '/recommendations/products';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          wrap.style.display = 'none';
          return;
        }
        var seed = cart.items[0].product_id;
        // If cache already matches this seed, nothing to do.
        if (upsellCacheHTML && upsellCacheSeed === seed && !injectAfter) return;

        return fetch(base + '?section_id=etq-cart-recommendations&product_id=' + seed + '&limit=6&intent=related')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var list = doc.querySelector('.etq-upsell__list');
            if (list && list.querySelectorAll('.etq-upsell__card').length > 0) {
              upsellCacheHTML = list.outerHTML;
              upsellCacheSeed = seed;
              if (injectAfter) {
                var t = document.getElementById('etq-upsell-scroll');
                var w = document.getElementById('etq-upsell');
                if (t && w) { t.innerHTML = upsellCacheHTML; w.style.display = ''; bindUpsellAdd(); }
              }
            } else if (injectAfter) {
              wrap.style.display = 'none';
            }
          });
      })
      .catch(function () { /* leave as-is */ });
  }

  // ----- Permanent guard -----
  // Watches the cart drawer. Whenever the upsell section ends up empty (e.g.
  // after a re-render replaces the node), it auto-refills. This is timing-proof:
  // it reacts to the section being wiped instead of trying to predict it.
  var upsellGuardActive = false;
  var upsellRefilling = false;
  function startUpsellGuard() {
    if (upsellGuardActive) return;
    var cartRoot = document.getElementById('CartDrawer');
    if (!cartRoot) { setTimeout(startUpsellGuard, 500); return; }
    upsellGuardActive = true;

    var observer = new MutationObserver(function () {
      var wrap = document.getElementById('etq-upsell');
      var scroll = document.getElementById('etq-upsell-scroll');
      if (!wrap || !scroll) return;
      var hasCards = scroll.querySelectorAll('.etq-upsell__card').length > 0;
      if (!hasCards && !upsellRefilling) {
        upsellRefilling = true;
        loadUpsell(true);
        setTimeout(function () { upsellRefilling = false; }, 800);
      }
    });
    observer.observe(cartRoot, { childList: true, subtree: true });
  }

  // Initial load (cart page or already-open drawer) + start the guard.
  loadUpsell();
  startUpsellGuard();
  document.addEventListener('DOMContentLoaded', function () {
    loadUpsell();
    startUpsellGuard();
  });

  // ----- Upsell ADD to cart (refresh drawer, never close) -----
  function bindUpsellAdd() {
    var buttons = document.querySelectorAll('.etq-upsell__add');
    buttons.forEach(function (btn) {
      if (btn.dataset.etqBound === '1') return;
      btn.dataset.etqBound = '1';
      // Capture-phase + stopPropagation so the click never reaches Dawn's
      // close/overlay handlers (this is what closed the drawer before).
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addUpsellItem(btn);
      }, true);
    });
  }

  function addUpsellItem(btn) {
    if (btn.disabled || btn.dataset.adding === '1') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.dataset.adding = '1';
    if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim() || 'Add';
    btn.textContent = 'Adding…';

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = (cartDrawer && cartDrawer.getSectionsToRender)
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { // error response carries a status field
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = btn.dataset.label; btn.dataset.adding = '0'; }, 1500);
          return;
        }
        // Refresh the drawer (items, totals) without closing it.
        // The guard observer refills the upsell automatically after the swap.
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(res);
        }
        refreshCartExtras();

        btn.textContent = 'Added \u2713';
        setTimeout(function () { btn.textContent = btn.dataset.label; btn.dataset.adding = '0'; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = btn.dataset.label; btn.dataset.adding = '0'; }, 1500);
      });
  }

  document.addEventListener('DOMContentLoaded', bindUpsellAdd);
  bindUpsellAdd();
  (function watchUpsellAdd() {
    var t = document.getElementById('CartDrawer');
    if (!t) { setTimeout(watchUpsellAdd, 500); return; }
    new MutationObserver(bindUpsellAdd).observe(t, { childList: true, subtree: true });
  })();
})();